import {gql} from '@apollo/client/core';


export const ProductAllMetaFragment = gql`
  fragment productAllMeta on WineMeta {
    id
    producerName
    units {
      shortName
    }
    ratings {
      id
      label
      rating
      name
      starCount
    }
    foods {
      label
      iconName
      path
    }
    grapes
    nutritionalInfoUrl
    allergens
    savingPotential
    alcohol
    contents
    contentLabel
    serving
    countryName
    districtName
    producerName
    wineType
    productType
    productSubType
    vintage
    port_type
    energyLabel
    energyLabelDoc
    productDataSheet
  }
`;
